function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoBackupTemplate = require('./saito-backup.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');

/*
  Installed by Saito Header
*/
var SaitoBackup = /*#__PURE__*/function () {
  function SaitoBackup(app, mod) {
    var _this = this;
    _classCallCheck(this, SaitoBackup);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.msg = null;
    this.title = null;
    this.success_callback = null;
    this.app.connection.on('saito-backup-render-request', /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(obj) {
        var key;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              key = _this.app.keychain.returnKey(_this.publicKey);
              if (!(key !== null && key !== void 0 && key.email && key !== null && key !== void 0 && key.wallet_decryption_secret && key !== null && key !== void 0 && key.wallet_retrieval_hash)) {
                _context.n = 1;
                break;
              }
              _this.app.connection.emit('recovery-backup-overlay-render-request', obj);
              return _context.a(2);
            case 1:
              _this.app.options.wallet.backup_required = (obj === null || obj === void 0 ? void 0 : obj.msg) || false;
              _this.msg = (obj === null || obj === void 0 ? void 0 : obj.msg) || 'Protect your balances, contacts, and keys by downloading a snapshot of your current wallet state';
              _this.title = (obj === null || obj === void 0 ? void 0 : obj.title) || 'WALLET BACKUP';
              _this.success_callback = function () {
                delete _this.app.options.wallet.backup_required;
                _this.overlay.remove();
                if (obj.success_callback) {
                  obj.success_callback();
                }
              };
              _context.n = 2;
              return _this.render();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  }
  return _createClass(SaitoBackup, [{
    key: "render",
    value: function render() {
      if (!document.getElementById('backup-template')) {
        this.overlay.show(SaitoBackupTemplate(this), this.callBackFunction.bind(this));
      } else {
        this.app.browser.replaceElementById(SaitoBackupTemplate(this), 'backup-template');
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      var this_self = this;

      // "no. backup manually" --> download wallet json
      document.querySelector('#saito-backup-manual').addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.app.wallet.backupWallet();
            case 1:
              _this2.success_callback();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      })));

      // "yes, make it easy" --> ??
      if (document.querySelector('#saito-backup-auto')) {
        document.querySelector('#saito-backup-auto').addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _this2.app.connection.emit('recovery-backup-overlay-render-request', {
                  success_callback: _this2.success_callback
                });
              case 1:
                return _context3.a(2);
            }
          }, _callee3);
        })));
      }
    }
  }, {
    key: "callBackFunction",
    value: function () {
      var _callBackFunction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this$app$options$wal;
        var this_self;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              this_self = this;
              if ((_this$app$options$wal = this.app.options.wallet) !== null && _this$app$options$wal !== void 0 && _this$app$options$wal.backup_required) {
                console.log('Set flashing reminder from saito-backup');
                this_self.app.connection.emit('saito-header-update-message', {
                  msg: 'wallet backup required',
                  flash: true,
                  callback: function callback() {
                    this_self.app.connection.emit('saito-backup-render-request', {
                      msg: this_self.msg,
                      title: this_self.title
                    });
                  }
                });
              }
              _context4.n = 1;
              return this.app.wallet.saveWallet();
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function callBackFunction() {
        return _callBackFunction.apply(this, arguments);
      }
      return callBackFunction;
    }()
  }]);
}();
module.exports = SaitoBackup;